import { createAction } from '@reduxjs/toolkit';
import {
  QueryPanelActionTypes,
  ItemCountRequest,
  ItemCountResponse,
  SubjectGradeInfoRequest,
  SubjectGradeInfoResponse
} from './models';


// Use createAction helper functions since they are stictly typed out of the box

export const loadAllSGInfoStart = createAction(QueryPanelActionTypes.LOAD_ALL_SG_INFO_START);

export const loadAllSGInfoSuccess = createAction(
  QueryPanelActionTypes.LOAD_ALL_SG_INFO_SUCCESS,
  (payload: SubjectGradeInfoResponse) => ({ payload })
);

export const loadAllSGInfoFailure = createAction(
  QueryPanelActionTypes.LOAD_ALL_SG_INFO_FAILURE,
  (errMsg: unknown) => ({
    payload: errMsg,
  })
);

export const loadSGInfoStart = createAction(
  QueryPanelActionTypes.LOAD_SG_INFO_START,
  (payload: SubjectGradeInfoRequest) => ({payload})
);

export const loadSGInfoSuccess = createAction(
  QueryPanelActionTypes.LOAD_SG_INFO_SUCCESS,
  (payload: SubjectGradeInfoResponse) => ({ payload })
);

export const loadSGInfoFailure = createAction(
  QueryPanelActionTypes.LOAD_SG_INFO_FAILURE,
  (errMsg: unknown) => ({
    payload: errMsg,
  })
);

export const resetSGInfo = createAction(
  QueryPanelActionTypes.RESET_SG_INFO
);

export const loadItemCountStart = createAction(
  QueryPanelActionTypes.LOAD_ITEM_COUNT_START,
  (payload: ItemCountRequest) => ({payload})
);

export const loadItemCountSuccess = createAction(
  QueryPanelActionTypes.LOAD_ITEM_COUNT_SUCCESS,
  (payload: ItemCountResponse) => ({ payload })
);

export const loadItemCountFailure = createAction(
  QueryPanelActionTypes.LOAD_ITEM_COUNT_FAILURE,
  (errMsg: unknown) => ({
    payload: errMsg,
  })
);

export const resetItemCount = createAction(
  QueryPanelActionTypes.RESET_ITEM_COUNT
);

